import React from "react";
import PropTypes from "prop-types";
import Image from "components/Image";
import "./CardHover.scss";

const CardHover = (props) => {
  const { imageCover, title, description, labels, link } = props;
  return (
    <a
      className="card-link"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      //   to={getBaseUrl(defaultLang, key)}
      //   className={clsx("dropdown-item", { active: key === langKey })}
    >
      <div className="card-hover">
        <Image fileName={imageCover} alt={title} />
        <div className="card-hover-body">
          <h2>{title}</h2>
          <p>{description}</p>
          {/* {labels.split(",").map((label, idx) => {
          return <h5 key={label}>{label}</h5>;
        })} */}
          <h5>{labels}</h5>
        </div>
      </div>
    </a>
  );
};

CardHover.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  imageCover: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  labels: PropTypes.string.isRequired,
};

export default CardHover;
